import { useState } from 'react';
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { InfoCard, Link } from '@backstage/core-components';
import { useQuickLinks } from './useQuickLinks';
import { QuickLinksEditor } from './QuickLinksEditor';

const useStyles = makeStyles(theme => ({
  linkItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 0),
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  icon: {
    fontSize: '1rem',
    flexShrink: 0,
  },
  editButton: {
    padding: theme.spacing(0.5),
  },
  cardTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

export const QuickLinksDisplay = () => {
  const classes = useStyles();
  const { links, loading, saveLinks } = useQuickLinks();
  const [editorOpen, setEditorOpen] = useState(false);

  const title = (
    <Box className={classes.cardTitle}>
      <span>Links</span>
      <Tooltip title="Customize links">
        <IconButton
          className={classes.editButton}
          size="small"
          onClick={() => setEditorOpen(true)}
          aria-label="edit links"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );

  return (
    <>
      <InfoCard title={title}>
        {loading ? (
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <Grid container spacing={1}>
            {links.map(link => (
              <Grid item xs={12} sm={6} key={link.id}>
                <Link to={link.url} className={classes.linkItem}>
                  <OpenInNewIcon className={classes.icon} />
                  <Typography variant="body2" noWrap>
                    {link.title}
                  </Typography>
                </Link>
              </Grid>
            ))}
          </Grid>
        )}
      </InfoCard>

      <QuickLinksEditor
        open={editorOpen}
        links={links}
        onSave={async newLinks => {
          const result = await saveLinks(newLinks);
          if (result.ok) {
            setEditorOpen(false);
          }
          return result;
        }}
        onClose={() => setEditorOpen(false)}
      />
    </>
  );
};
